import React from 'react';
import { Link } from 'react-router-dom';
import start_icon from '../../assets/images/icons/star.svg'

const WoowiiFeedbackSingle = ({ element, type = 1 }) => {
    return (
        <div className={`blog-single ${ type === 1 ? 'blog-single-1': '' }`}>
            <div className="blog-single-wrapper">
                <div className="blog-single-content">
                        <Link to={element.url} className="figure">
                            <img style={{ objectFit: 'contain' }} src={element.thumbnail} alt="blog-thumbnail"  />
                            {  type === 2 ? (
                                <div className="img-hover">
                                    <div className="icon">
                                        <i className="las la-link"></i>
                                    </div>
                                </div>
                                )  : ''
                            }
                            
                        </Link>
                        <Link to={element.url}>
                            <h3 class="text-center" style={{color:"black"}}>{element.title}</h3>
                            <h4 class="text-center" style={{color:"black", fontWeight:"400"}}> {element.subtitle}</h4>
                        </Link>
                        <div className="blog-single-details">
                        </div>
                        <p class="text-center mb-5" style={{color:"black"}}>{element.excerpt}</p>
                        
                        <img class="me-3" src={start_icon}></img>
                        <img class="me-3" src={start_icon}></img>
                        <img class="me-3" src={start_icon}></img>
                        <img class="me-3" src={start_icon}></img>
                        <img class="me-3" src={start_icon}></img>
                        {/* <div class="container text-center mt-5">
                            <span class="fs-3" style="color: gold;">&#9733;</span>
                            <span class="fs-3" style="color: gold;">&#9733;</span>
                            <span class="fs-3" style="color: gold;">&#9733;</span>
                            <span class="fs-3" style="color: gold;">&#9733;</span>
                            <span class="fs-3" style="color: gold;">&#9733;</span>
                        </div> */}
                </div>
            </div>
        </div>
    );
};

export default WoowiiFeedbackSingle;
